import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "005_backfill_credit_note_numbers",
  version: "1.3.1",
  ignoreErrors: ["no such table: accounting_invoices"],
  sql: `
WITH candidates AS (
  SELECT
    \`id\`,
    COALESCE(NULLIF(substr(\`invoice_date\`, 1, 4), ''), strftime('%Y', 'now')) AS doc_year,
    \`invoice_date\`,
    \`created_at\`
  FROM \`sales_credit_notes\`
  WHERE \`invoice_type\` = 'credit_note'
    AND \`invoice_no\` NOT GLOB 'CN-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
),
existing AS (
  SELECT
    substr(\`invoice_no\`, 4, 4) AS doc_year,
    MAX(CAST(substr(\`invoice_no\`, 9) AS INTEGER)) AS max_seq
  FROM \`sales_credit_notes\`
  WHERE \`invoice_type\` = 'credit_note'
    AND \`invoice_no\` GLOB 'CN-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
  GROUP BY substr(\`invoice_no\`, 4, 4)
),
numbered AS (
  SELECT
    candidates.\`id\`,
    'CN-' || candidates.doc_year || '-' || printf(
      '%05d',
      COALESCE(existing.max_seq, 0)
        + ROW_NUMBER() OVER (
          PARTITION BY candidates.doc_year
          ORDER BY candidates.\`invoice_date\`, candidates.\`created_at\`, candidates.\`id\`
        )
    ) AS new_invoice_no
  FROM candidates
  LEFT JOIN existing ON existing.doc_year = candidates.doc_year
)
UPDATE \`accounting_invoices\`
SET
  \`invoice_no\` = (SELECT numbered.new_invoice_no FROM numbered WHERE numbered.\`id\` = \`accounting_invoices\`.\`id\`),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (SELECT \`id\` FROM numbered);

UPDATE \`sales_credit_notes\`
SET
  \`invoice_no\` = (
    SELECT \`accounting_invoices\`.\`invoice_no\`
    FROM \`accounting_invoices\`
    WHERE \`accounting_invoices\`.\`id\` = \`sales_credit_notes\`.\`id\`
  ),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`id\` IN (
  SELECT \`id\`
  FROM \`accounting_invoices\`
  WHERE \`invoice_type\` = 'credit_note'
    AND \`invoice_no\` GLOB 'CN-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
);

WITH current_year_max AS (
  SELECT COALESCE(MAX(CAST(substr(\`invoice_no\`, 9) AS INTEGER)), 0) AS max_seq
  FROM \`sales_credit_notes\`
  WHERE \`invoice_type\` = 'credit_note'
    AND substr(\`invoice_no\`, 4, 4) = strftime('%Y', 'now')
    AND \`invoice_no\` GLOB 'CN-[0-9][0-9][0-9][0-9]-[0-9][0-9][0-9][0-9][0-9]'
)
UPDATE \`core_numbering_series\`
SET
  \`prefix\` = CASE
    WHEN \`prefix\` LIKE 'INV-%' THEN 'CN-{YYYY}-#####'
    ELSE \`prefix\`
  END,
  \`current_value\` = (SELECT max_seq FROM current_year_max),
  \`reset_every\` = 'yearly',
  \`last_reset_year\` = CAST(strftime('%Y', 'now') AS INTEGER),
  \`updated_at\` = strftime('%Y-%m-%dT%H:%M:%fZ', 'now')
WHERE \`module\` = 'sales'
  AND \`doctype\` = 'credit_note'
  AND \`is_default\` = 1
  AND ((SELECT max_seq FROM current_year_max) > 0 OR \`prefix\` LIKE 'INV-%');
  `.trim(),
};
